import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'rtr-payment-blik',
  styleUrl: '../style.sass',
  shadow: false,
})
export class RtrPaymentBlik {
  @Prop() onBlikCodeChange: (code: string) => void;
  inputs: HTMLInputElement[] = Array(6); // reference to the internal

  handleCodeSplitInput = (index: number, event) => {
    const inputValue = event.target.value;

    if (inputValue.length > 1) {
      this.inputs[index].value = inputValue[inputValue.length - 1];
    }

    if (!inputValue || isNaN(inputValue)) {
      this.inputs[index].value = null;
    }

    this.onBlikCodeChange?.(this.reduceCode());

    // if value is correct then jump to next input field
    if (event.target.value) {
      this.inputs[index + 1]?.focus();
    }
  };

  reduceCode(): string {
    return this.inputs.map(item => (item ? item.value : '')).reduce((accumulator, currentValue) => accumulator + currentValue, '');
  }

  renderSingleField(index: number) {
    return (
      <input
        ref={el => (this.inputs[index] = el)}
        name={'code_' + index}
        onInput={e => this.handleCodeSplitInput(index, e)}
        placeholder="0"
        class="RTPBLikField"
        type="number"
        min={0}
        max={9}
      />
    );
  }

  render() {
    return (
      <Host class="RTPBLik">
        <rentware-spacer size="L" />

        <span class="RTPTitle">Podaj kod blik, aby zapłacić</span>

        <rentware-spacer size="S" />

        <div class="RTPBLikFields">
          {this.renderSingleField(0)}
          {this.renderSingleField(1)}
          {this.renderSingleField(2)}
          <div class="RTPBLikSeparator" />
          {this.renderSingleField(3)}
          {this.renderSingleField(4)}
          {this.renderSingleField(5)}
        </div>

        <rentware-spacer size="S" />
      </Host>
    );
  }
}
